import type { FC } from "react";
import React from "react";
import { Navigate } from "react-router-dom";

import { hasValue } from "@core/foundation/types";

import { ErrorView, LoadingView } from "@react/foundation/placeholder";

import { router } from "../../../bootstrap/router.ts";
import { useAppNavigation } from "../../../shared/hooks/useAppNavigation.ts";
import {
  signinOnReturnSelectors,
  useSigninOnReturnStore,
} from "../state/signin-on-return.ts";

export const AuthCallbackView: FC = () => {
  const error = useSigninOnReturnStore(signinOnReturnSelectors.error);

  const isPending = useSigninOnReturnStore(signinOnReturnSelectors.isPending);

  const { goToDashboard } = useAppNavigation();

  if (isPending) {
    return <LoadingView />;
  }

  if (hasValue(error)) {
    return (
      <ErrorView
        actionLabel="Go to Dashboard"
        description={error}
        onAction={goToDashboard}
      />
    );
  }

  return <Navigate replace to={router.getUrl("Dashboard")} />;
};
